import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { ISalesOrderInit } from "../../../declarations/ISalesOrderInit";

const getSalesOrderInit = async (
    orderID: number,
): Promise<ISalesOrderInit> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<ISalesOrderInit>(
        `/SalesOrder/GetSalesOrderInitFromOrderID/${orderID}`,
    );
    return response.data;
};

export const useGetSalesOrderInit = (orderID: number) =>
    useQuery<ISalesOrderInit>({
        enabled: orderID > 0,
        queryFn: () => getSalesOrderInit(orderID),
        queryKey: ["GetSalesOrderInit", orderID],
        refetchOnWindowFocus: false,
        retry: false,
    });
